import { Component, OnInit } from "@angular/core";
import { AppDataPipe } from "@shared/pipes/app-data.pipe";
import { AssetsSourcePipe } from "@shared/pipes/assets-source.pipe";
import { AppConfigService } from "./configs/app-config.service";

@Component({
	selector: "app-root",
	templateUrl: "./app.component.html",
	styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit {
	title = "whatsauto-webclient";

	favIcon: HTMLLinkElement =
		document.querySelector("#appIcon") ?? new HTMLLinkElement();

	changeIcon() {
		this.favIcon.href = this.assetsSource.transform("favicon.ico");
	}

	changeTitle() {
		document.title = this.appData.transform("WhatsAuto");
	}

	constructor(
		private assetsSource: AssetsSourcePipe,
		private appData: AppDataPipe,
		private appConfig: AppConfigService
	) {
		this.changeIcon();
		this.changeTitle();
	}

	ngOnInit() {
		const appName = this.appConfig.get("appName");

		this.title = appName;
		document.title = appName;
	}
}
